(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-card-swatches"] && !Shopify.designMode) return;
  try {
    const cache = new Map();

const addWidth = (url, width) => {
  if (!url) return url;
  return url + (url.includes('?') ? '&' : '?') + `width=${width}`;
};

const buildSrcset = (url) => {
  if (!url) return '';
  return [240, 352, 832, 1200, 1600, 1920].map(w => `${addWidth(url, w)} ${w}w`).join(', ');
};

const prefetch = async (productUrl) => {
  if (cache.has(productUrl)) return;
  try {
    const response = await fetch(`${productUrl}.js`);
    const data = await response.json();
    cache.set(productUrl, data.images);
  } catch (e) {}
};

const applyImages = (card, images, swatch) => {
  const allImages = card.querySelectorAll('img.product-media__image');

  if (allImages[0]) {
    allImages[0].srcset = buildSrcset(images[0]);
    allImages[0].src = addWidth(images[0], 1200);
  }
  if (allImages[1] && images[1]) {
    allImages[1].srcset = buildSrcset(images[1]);
    allImages[1].src = addWidth(images[1], 1200);
  }

  const productCardLink = card.closest('product-card-link');
  if (productCardLink) {
    productCardLink.setAttribute('data-featured-media-url', addWidth(images[0], 1200));
  }

  swatch.closest('.swatches')
    .querySelectorAll('.swatch-sibling')
    .forEach(s => s.classList.remove('is-active'));
  swatch.classList.add('is-active');
};

// Prefetch all siblings when card enters viewport
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    entry.target.querySelectorAll('a.swatch-sibling[data-product-url]').forEach(swatch => {
      prefetch(swatch.dataset.productUrl);
    });
    observer.unobserve(entry.target);
  });
}, { rootMargin: '200px' });

const observeCards = () => {
  document.querySelectorAll('product-card').forEach(card => observer.observe(card));
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', observeCards);
} else {
  observeCards();
}
// Also observe any cards added later (e.g. tab switches)
new MutationObserver(mutations => {
  mutations.forEach(m => {
    m.addedNodes.forEach(node => {
      if (node.nodeType !== 1) return;
      node.querySelectorAll?.('product-card').forEach(card => observer.observe(card));
    });
  });
}).observe(document.body, { childList: true, subtree: true });

// Scoped click handler
document.addEventListener('click', async (e) => {
  const swatch = e.target.closest('a.swatch-sibling[data-product-url]');
  if (!swatch) return;
  e.preventDefault();

  const card = swatch.closest('product-card');
  if (!card) return;

  const productUrl = swatch.dataset.productUrl;
  await prefetch(productUrl);
  const images = cache.get(productUrl);
  if (images) applyImages(card, images, swatch);
}, true);
  } catch(e) { console.error(e); }
})();

})();
